module.exports = __webpack_public_path__ + "img/busT - copia.3c3999b2.png";